<div class="filtro-busca-imobiliario-wrapper">
  <div class="filtros-col">
    <app-filtro-busca-salva-industrial
      [idModuloSelecionado]="idModuloSelecionado"
      [buscaSelecionada]="buscaSalvaId"
      (buscaSalvaChange)="onBuscaSalvaChange($event)"
    ></app-filtro-busca-salva-industrial>
    <app-filtro-regiao-industrial
      [buscaSalvaRegiao]="buscaSalvaRegiao"
      (filtrosChange)="onRegiaoFiltrosChange($event)"
      [disabled]="!temAcessoModulo && !modoEdicao"
    ></app-filtro-regiao-industrial>

    <app-filtro-detalhes-obra
      [idModuloSelecionado]="idModuloSelecionado"
      [detalhesSelecionados]="detalhesSelecionados"
      [bloqueandoAtualizacao]="bloqueandoAtualizacao"
      (detalhesChange)="onDetalheSelecionado($event)"
    >
    </app-filtro-detalhes-obra>
    <app-filtro-setor-obra
      [idModuloSelecionado]="idModuloSelecionado"
      [setoresSelecionados]="setoresSelecionados"
      [bloqueandoAtualizacao]="bloqueandoAtualizacao"
      (setorChange)="onSetorSelecionado($event)"
    >
    </app-filtro-setor-obra>
    <app-filtro-tipo-obra-industrial
      [idModuloSelecionado]="idModuloSelecionado"
      [tiposObraSelecionados]="tiposObraSelecionados"
      [bloqueandoAtualizacao]="bloqueandoAtualizacao"
      (tipoObraChange)="onTipoObraSelecionado($event)"
    >
    </app-filtro-tipo-obra-industrial>
    <app-filtro-cronograma
      [idModuloSelecionado]="idModuloSelecionado"
      [cronogramaSelecionados]="cronogramaSelecionados"
      [bloqueandoAtualizacao]="bloqueandoAtualizacao"
      (cronogramaChange)="onCronogramaSelecionado($event)"
      [disabled]="!temAcessoModulo && !modoEdicao"
    >
    </app-filtro-cronograma>
    <app-filtro-valor-obra
      [idModuloSelecionado]="idModuloSelecionado"
      (valorObraChange)="onValorObraSelecionado($event)"
      [disabled]="!temAcessoModulo && !modoEdicao"
    ></app-filtro-valor-obra>
    <app-filtro-cadastrada-em
      (cadastradaEmChange)="onCadastradaEmSelecionado($event)"
      [cadastradaEmSelecionado]="cadastradaEmSelecionado"
      [disabled]="!temAcessoModulo && !modoEdicao"
    ></app-filtro-cadastrada-em>
    <app-filtro-busca-somente
      [checkedOptionsIds]="checkedBuscarSomenteIds"
      (buscarSomenteChange)="onBuscarSomenteSelecionado($event)"
      [disabled]="!temAcessoModulo && !modoEdicao"
    ></app-filtro-busca-somente>
    <app-filtro-termino-obra
      (terminoObraChange)="onTerminoObraSelecionado($event)"
      [terminoObraSelecionado]="terminoObraSelecionado"
      [disabled]="!temAcessoModulo && !modoEdicao"
    >
    </app-filtro-termino-obra>

    <div
      class="tipo-de-obra-content titles"
      appDropdownToggle
      #dropdown="dropdownToggle"
      (click)="dropdown.toggle()"
      tabindex="0"
    >
      <div class="icon-text">
        <span class="icon-circle">
          <img
            class="img-icon"
            src="{{
              BASE_IMG_URL
            }}assets/filtro-lateral-busca/bookmark.svg"
            alt=""
            width="22"
            height="22"
          />
        </span>

        <h2>SALVAR BUSCA</h2>
      </div>
      <a
        class="btn tipo-de-obra-link"
        data-bs-toggle="collapse"
        role="button"
        aria-expanded="true"
        href="#BTN-SALVAR"
        (click)="$event.stopPropagation(); dropdown.toggle()"
        (keydown.enter)="dropdown.toggle()"
        (keydown.space)="dropdown.toggle()"
      >
        <img
          class="img-icon"
          [ngClass]="{ 'girar-icon': dropdown.isOpen }"
          src="{{
            BASE_IMG_URL
          }}assets/filtro-lateral-busca/icone-seta-fechar.svg"
          alt=""
          width="18"
          height="18"
        />
      </a>
    </div>

    <div class="collapse show check-total" id="BTN-SALVAR">
      <div class="form-check salvar-obra" *ngIf="!modoEdicao">
        <input
          type="text"
          placeholder="Nome busca"
          class="input-placeholder-italic"
          #nomeBuscaInput
          [disabled]="!temAcessoModulo && !modoEdicao"
        />
        <button
          (click)="salvarBusca()"
          type="button"
          [disabled]="!temAcessoModulo && !modoEdicao"
          [class.disabled]="!temAcessoModulo && !modoEdicao"
        >
          <span>SALVAR</span>
        </button>
      </div>
    </div>

    <div
      class="collapse show check-total"
      id="BTN-SALVAR-EDICAO"
      *ngIf="modoEdicao"
    >
      <div class="form-check salvar-obra-edit">
        <!-- <input
            type="text"
            placeholder="Nome da busca"
            class="input-placeholder-italic"
            #nomeBuscaEditadaInput
            [value]="savedSearchName"
            (input)="onNomeEdicaoChange($any($event.target).value)"
            [disabled]="!temAcessoModulo && !modoEdicao"
          /> -->
        <input
          type="text"
          placeholder="Nome da busca"
          class="input-placeholder-italic"
          #nomeBuscaEditadaInput
          [value]="savedSearchName"
          [disabled]="!temAcessoModulo && !modoEdicao"
        />
        <button
          (click)="salvarEdicaoBusca()"
          type="button"
          [disabled]="!temAcessoModulo && !modoEdicao"
        >
          <span>SALVAR EDIÇÃO</span>
        </button>
      </div>
    </div>

    <div class="limpar-filtros-industrial">
      <button
        type="button"
        (click)="limparFiltros()"
        [disabled]="!temAcessoModulo && !modoEdicao"
        [class.disabled]="!temAcessoModulo && !modoEdicao"
      >
        LIMPAR
      </button>
    </div>
  </div>
</div>
